import { render, staticRenderFns } from "./MyPortfolios.vue?vue&type=template&id=42f4cb62&scoped=true&"
import script from "./MyPortfolios.vue?vue&type=script&lang=js&"
export * from "./MyPortfolios.vue?vue&type=script&lang=js&"
import style0 from "./MyPortfolios.vue?vue&type=style&index=0&id=42f4cb62&scoped=true&lang=css&"
import style1 from "./MyPortfolios.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f4cb62",
  null
  
)

export default component.exports